import React, { memo } from "react";
import PropTypes from "prop-types";
import { Chip, Box, Tooltip } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import { formatCurrency } from "utils/currency";

const ClaseVinculadaChip = memo(({ claseVinculada, totalDeuda, onDesvincular }) => {
  return (
    <Chip
      icon={
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24 }}>
          <LinkIcon sx={{ fontSize: "inherit" }} />
        </Box>
      }
      deleteIcon={
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24 }}>
          <Tooltip title="Desvincular" placement="right">
            <LinkOffIcon sx={{ fontSize: "inherit" }} />
          </Tooltip>
        </Box>
      }
      label={
        <span>
          {claseVinculada} ({formatCurrency(totalDeuda).formatted})
        </span>
      }
      onDelete={onDesvincular}
      color="info"
      variant="outlined"
      sx={{
        "& .MuiChip-label": { whiteSpace: "normal" },
        "& .MuiChip-icon": { ml: "8px" },
      }}
    />
  );
});

ClaseVinculadaChip.propTypes = {
  claseVinculada: PropTypes.string.isRequired,
  totalDeuda: PropTypes.number.isRequired,
  onDesvincular: PropTypes.func.isRequired,
};

ClaseVinculadaChip.displayName = "ClaseVinculadaChip";

export default ClaseVinculadaChip;
